import _toString from "lodash/toString"
import { Map } from "immutable"

export const getSegmentsNumbers = (state, id) => {
  if (state.segmentsNumbers.has(_toString(id))) {
    return state.segmentsNumbers.get(_toString(id))
  }
  return Map()
}
